import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { AccountRoleWithAccountDetails } from "../../../../../../Wrap/Models/Domains/Customers/AccountRoleWithAccountDetails";
import { ContactPreferenceDetails } from "../../../../../../Wrap/Models/Models/Customer/ContactPreferenceDetails";
import { CustomerEmailAddress } from "../../../../../../Wrap/Models/Models/Customer/CustomerEmailAddress";
import { CustomerPhoneNumber } from "../../../../../../Wrap/Models/Models/Customer/CustomerPhoneNumber";
import { DeathDetails } from "../../../../../../Wrap/Models/Models/Customer/DeathDetails";
import { EmploymentDetail } from "../../../../../../Wrap/Models/Models/Customer/EmploymentDetail";
import { PersonalDetail } from "../../../../../../Wrap/Models/Models/Customer/PersonalDetail";
import { ClientRecordTab } from "../Resource/Contents";
import { ClientRecordDispatcher } from "./Variable";

export interface ClientRecordStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: {
        [ClientRecordTab.PersonalDetail]: PersonalDetail;
        [ClientRecordTab.AddressDetail]: any;
        [ClientRecordTab.ContactDetail]: CustomerPhoneNumber[];
        [ClientRecordTab.Regulatory]: any;
        [ClientRecordTab.RegulatoryChecks]: any;
        [ClientRecordTab.PensionProtection]: any;
        EmploymentDetail: EmploymentDetail;
        DeathDetail: DeathDetails;
        EmailDetail: CustomerEmailAddress[];
        ContactPerference: ContactPreferenceDetails;
    };
}

export class ClientRecordStatic extends BaseStore<ClientRecordStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ClientRecordDispatcher, (actionData) =>
            this.onClientRecordStoreResponse(actionData)
        );
    }

    public getLastResult(): ClientRecordStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): ClientRecordStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onClientRecordStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
